import React from "react";

const Cargando = () => {
  return (
    <div className="mt-5">
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      <p className="text-center">Cargando...</p>
    </div>
  );
};

export default Cargando;
